import { render, staticRenderFns } from "./CtaUrl.vue?vue&type=template&id=15bfc595&"
import script from "./CtaUrl.vue?vue&type=script&lang=js&"
export * from "./CtaUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports